/**
 * CodaDoor — the aside's way to the coda (plan 2026_09_23_pack_stage_coda.md § Decided 5). The
 * house's `onOpen` pages the stage to the coda, brings it into view and asks its field for focus —
 * a deliberate press on the same page, the one case where a phone keyboard may rise. On the phone
 * it sits under the thumb strip: the visible entry for the visitor who never pages.
 */
import {Pen} from '@core/wall/ui/Ghost'
import styles from './StagePieces.module.scss'

export interface CodaDoorProps {
    label: string
    onOpen: () => void
}

export function CodaDoor({label, onOpen}: CodaDoorProps) {
    return (
        <button type="button" className={styles.codaDoor} onClick={onOpen}>
            <span className={styles.doorPen} aria-hidden="true"><Pen /></span>
            <span>{label}</span>
        </button>
    )
}
